import axios from 'axios';

import CitizenConfig from '../config';
import { openModal } from './ModalLoginActions';
import { addNotification } from './ErrorActions';

export const REQUEST_SONG_FOR_ORDER = 'REQUEST_SONG_FOR_ORDER';
export const REMOVE_SONG_FOR_ORDER = 'REMOVE_SONG_FOR_ORDER';
export const RECEIVE_SONG_FOR_ORDER = 'RECEIVE_SONG_FOR_ORDER';

export const REQUEST_ORDERS_FROM_LOCAL = 'REQUEST_ORDERS_FROM_LOCAL';
export const RECEIVE_ORDERS_FROM_LOCAL = 'RECEIVE_ORDERS_FROM_LOCAL';

export const REQUEST_ORDER = 'REQUEST_ORDER';
export const REQUEST_ORDER_PENDING = 'REQUEST_ORDER_PENDING';
export const REQUEST_ORDER_FULLFILLED = 'REQUEST_ORDER_FULLFILLED';
export const REQUEST_ORDER_REJECTED = 'REQUEST_ORDER_REJECTED';

const ORDER_REQUEST_URL = `${CitizenConfig.API_URL}/wc/v2/orders`;

function requestOrderSong() {
  return {
    type: REQUEST_SONG_FOR_ORDER,
  };
}

function receiveOrderSong(song) {
  return {
    song,
    type: RECEIVE_SONG_FOR_ORDER,
  };
}

function requestOrdersFromLocal() {
  return {
    type: REQUEST_ORDERS_FROM_LOCAL
  }
}

function receiveOrdersFromLocal(orders) {
  return {
    items: orders,
    type: RECEIVE_ORDERS_FROM_LOCAL
  }
}

export function requestSong(song) {
  return (dispatch, getState) => {
    let { user } = getState();

    dispatch(requestOrderSong(song));
    
    let localStorageOrders = JSON.parse(localStorage.getItem('orders'));
    let orders = localStorageOrders ? localStorageOrders : [];

    let orderExist = orders.find( (order, i) => {
      
      return order.id === song.id;
    })

    if (orderExist) {
      // console.log('Order exists');
    } else {
      let savedOrders = JSON.stringify([...orders, song]);
      

      localStorage.setItem('orders', savedOrders);
      dispatch(addNotification('Song added to orders.', 'success'));
      dispatch(receiveOrderSong(song));
    }

    if (!user.authenticated) {
      dispatch(openModal());
    }
  };
}

export function requestOrdersFromLocalStorage() {
  return (dispatch) => {
    dispatch(requestOrdersFromLocal());
    let localStorageOrders = JSON.parse(localStorage.getItem('orders'));
    let orders = localStorageOrders ? localStorageOrders : [];
    
    return dispatch(receiveOrdersFromLocal(orders));
  };
}

function requestOrders() {
  return {
    type: REQUEST_ORDER
  }
}

function receiveOrders() {
  return {
    type: REQUEST_ORDER_FULLFILLED
  }
}

export function requestOrder(orderData, token, history) {
  return async (dispatch, getState)  => {

    dispatch(requestOrders());

    await axios.post(ORDER_REQUEST_URL, orderData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    
    history.push('/profile/order-history');

    dispatch(addNotification('Thank you for your order request! We will follow up soon with an email.', 'success'));
    return dispatch(receiveOrders());
  };
}

export function removeSongFromOrder(song) {
  return (dispatch, getState) => {
    dispatch(requestOrdersFromLocal());
    let state = getState();
    let newOrders = state.orders.items.filter( (order, i) => order.id !== song.id);
    let savedOrders = JSON.stringify([...newOrders]);

    localStorage.setItem('orders', savedOrders);
    
    return dispatch(receiveOrdersFromLocal(newOrders));
  };
}


// WEBPACK FOOTER //
// ./src/actions/OrderActions.js